export const local_baseURL = 'http://10.21.205.171/egaji-api/api'
export const staging_baseURL = 'http://10.21.0.155/egaji-api8/api'
export const live_baseURL = 'https://ssg.jpa.gov.my/egaji-api8/api'
//export const live_baseURL = 'http://10.21.0.26/egaji-api/api'
export const notebook_baseURL = 'http://192.168.202.56/egaji-api/api'
export const local8_baseURL = 'http://10.21.205.191/egaji-api8/api'
export const local8_rumah = 'http://192.168.1.109/egaji-php8/api'
export const baseURL = live_baseURL